export default __webpack_public_path__ + "static/media/flat,750x1000,075,f.21a1adb5.jpg";